/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface FolderModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class FolderApiService extends SignalAdminResourceApiBase<FolderModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'folders');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<FolderModel>> {
    return this.client.request<SignalAdminResourcePage<FolderModel>>({
      method: 'GET',
      url: this.resourceUri('folders'),
      params
    });
  }

  bulkSave(models: Partial<FolderModel>[]): Observable<void> {
    return this.saveMany(models);
  }
}
